import {currencyFormatter} from '@homeaway/hacommons-i18n';

const getCurrencySymbol = (currencyCode) => {
    return currencyFormatter.symbol(currencyCode);
};

export default getCurrencySymbol;
